import {TUserRole} from '../../common-code/types/TUserRole';
import {IUserData} from '../../common-code/interfaces/IUserData';
import {useSelector} from 'react-redux';
import {AppState} from '../redux/AppStore';
import {ROLE_MANAGER, ROLE_GUEST, ROLE_ADMIN} from '../../common-code/constants';

export const useUserRole = (): TUserRole => {
    const user: IUserData = useSelector((state: AppState) => state.user);
    const normaleRoles: string[] = user.roles && user.roles.length ? user.roles.map(item => item.toUpperCase()) : [];

    if (normaleRoles.includes(ROLE_ADMIN.toUpperCase())) {
        return ROLE_ADMIN;
    }
    if (normaleRoles.includes(ROLE_MANAGER.toUpperCase())) {
        return ROLE_MANAGER;
    }

    return ROLE_GUEST;
}